<template>
  <div class="line">
    <span class="muted">{{ prefix }}</span>
    <span class="strong">{{ price }}</span>
    <span class="muted">{{ suffix }}</span>
  </div>
</template>

<script>
export default {
  name: 'PlanPriceLine',
  props: {
    prefix: {
      type: String,
      default: 'Then'
    },
    price: {
      type: String,
      default: '$1799.88 / year'
    },
    suffix: {
      type: String,
      default: 'after Dec 22, 2025'
    }
  }
}
</script>

<style scoped>
.line {
  display: flex;
  gap: 4px;
}

.muted {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: rgba(9, 21, 64, 0.68);
}

.strong {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #091540;
}
</style>
